const Urls = {
  // Meta API - User
  AddOrgan: "/api/user/addorgan",
  UpdateUser: "/api/user/update",

  // Meta API - Password
  ChangePassword: "/api/login/changepassword",
  ForgotPassword: "/api/login/forgotpassword",

  // Meta API - TABLES
  AA_DEF_OB: "/api/aadefob",
  ZP_SPRAVY_UZ: "/api/zpspravyuz",

  // Data API
  Dodavatel: "/api/dodavatel",
  Faktury: "/api/faktury",
  FakturaPDF: "/api/faktury/pdf",
  Odberatel: "/api/odberatel",
  OdberneMiesto: "/api/odberneMiesto",
  Spotreby: "/api/spotreba",
  Zmluvy: "/api/zmluvy",
};

export default Urls;
